<script>
import {useCatalogStore} from "@js/store/CatalogStore.js";
import CatalogFilter from "@js/components/Sections/Catalog/CatalogFilter.vue";
import IconX from "@js/components/Icons/IconX.vue";

export default {
    name: "CatalogMobileFilter",
    components: {IconX, CatalogFilter},
    setup() {
        const catalogStore = useCatalogStore()

        return {catalogStore}
    }
}
</script>

<template>
    <div>
        <div
            class="fixed inset-y-0 left-0 z-50 w-full bg-white shadow-lg transform transition-transform duration-300"
            :class="{ '-translate-x-full': !catalogStore.is_filter_open, 'translate-x-0': catalogStore.is_filter_open }">
            <div class="flex flex-col h-full pt-4">
                <div class="px-4">
                    <button @click.prevent="catalogStore.toggleFilter"
                            class="mb-4 rounded-md focus:outline-none float-end">
                        <IconX class="w-6 h-6"/>
                    </button>
                </div>
                <div class="flex-grow overflow-y-auto max-h-full px-4">
                    <CatalogFilter/>
                </div>
                <div class="mt-auto px-4 py-2 border-t border-gray-200 shadow-lg">
                    <div class="w-full ">
                        <button type="button" @click.prevent="catalogStore.toggleFilter"
                                class="w-full mt-2 text-[#2D2D2D] border-2 border-baseColor font-medium rounded-lg px-5 py-2.5 text-center me-2 mb-2">
                            Применить фильтр
                            <span v-if="catalogStore.selected_filters.length" class="ms-1">
                                ({{ catalogStore.selected_filters.length }})
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Overlay -->
        <div
            v-if="catalogStore.is_filter_open"
            @click.prevent="catalogStore.toggleFilter"
            class="fixed inset-0 bg-black bg-opacity-50 z-40"
        ></div>
    </div>
</template>

<style scoped lang="scss">

</style>
